angular.module('impactx.search').component('ixContactItem', {
        bindings: {
            contact: '<',
            trns: '<',
            baseObject: "<"
        },
        controller: 'ContactItemCtrl',
        templateUrl: 'modules/search/templates/contact-item.html'
    }
);
